(function () {
  const CFG = window.TN_UPSELL || window.FF_UPSELL || {};
  const moneyFormat = CFG.moneyFormat || "${{amount}}";
  const locale = CFG.locale || "es-CO";
  const currency = CFG.currency || "COP";

  const SECTION_HANDLES = Array.isArray(CFG.sections) && CFG.sections.length
    ? CFG.sections
    : ["cart-drawer", "cart-icon-bubble"];

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    try {
      return new Intl.NumberFormat(locale, { style: "currency", currency }).format((cents || 0) / 100);
    } catch {
      return "$" + ((cents || 0) / 100).toFixed(2);
    }
  }

  async function fetchJSON(url) {
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error("HTTP " + res.status);
    return res.json();
  }

  function uniqByHandle(list) {
    const seen = new Set();
    return (list || []).filter((p) => {
      if (!p || !p.handle) return false;
      if (seen.has(p.handle)) return false;
      seen.add(p.handle);
      return true;
    });
  }

  function shuffle(arr) {
    const a = (arr || []).slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  function getImageUrl(p) {
    if (!p) return "";

    if (typeof p.featured_image === "string") return p.featured_image;
    if (p.featured_image && typeof p.featured_image === "object") {
      return p.featured_image.url || p.featured_image.src || "";
    }

    if (p.image && typeof p.image === "object") return p.image.src || p.image.url || "";
    if (typeof p.image === "string") return p.image;

    const img0 = (p.images && p.images[0]) ? p.images[0] : "";
    if (typeof img0 === "string") return img0;
    if (img0 && typeof img0 === "object") return img0.src || img0.url || "";

    return "";
  }

  function getProductUrl(p) {
    if (p && p.url) return p.url;
    if (p && p.handle) return "/products/" + p.handle;
    return "#";
  }

  function escapeAttr(str) {
    return String(str || "").replace(/"/g, "&quot;");
  }

  function cardHTML(product) {
    const img = getImageUrl(product);
    const url = getProductUrl(product);
    const title = product.title || product.handle || "Producto";
    const handle = product.handle || "";

    return `
      <div class="tn-upsell-card" data-tn-upsell-card data-product-handle="${escapeAttr(handle)}">
        <div class="tn-upsell-card__inner">
          <a class="tn-upsell-card__media" href="${url}" aria-label="${escapeAttr(title)}">
            ${img ? `<img loading="lazy" src="${img}" alt="${escapeAttr(title)}">` : ``}
          </a>

          <div class="tn-upsell-card__content">
            <p class="tn-upsell-card__title">
              <a href="${url}">${title}</a>
            </p>

            <div class="tn-upsell-card__price" data-tn-price>—</div>

            <div class="tn-upsell-card__actions">
              <button class="tn-upsell-card__btn" type="button" data-tn-add disabled>
                Cargando...
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function storageKey(block) {
    const ctx = block.dataset.context || "unknown";
    const mode = block.dataset.mode || "auto";
    const collectionHandle = block.dataset.collectionHandle || "";

    if (ctx === "product") {
      return `tnUpsell:${ctx}:${mode}:${block.dataset.productId || ""}:${collectionHandle}`;
    }

    if (ctx === "cart-drawer" || ctx === "cart") {
      const firstProductId = block.dataset.firstProductId || block.dataset.productId || "";
      const cartProductIds = (block.dataset.cartProductIds || "")
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean)
        .join("-");

      return `tnUpsell:${ctx}:${mode}:${firstProductId}:${cartProductIds}:${collectionHandle}`;
    }

    return `tnUpsell:${ctx}:${mode}:${collectionHandle}`;
  }

  function loadHandles(key) {
    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch {
      return [];
    }
  }

  function saveHandles(key, handles) {
    try {
      sessionStorage.setItem(key, JSON.stringify((handles || []).filter(Boolean)));
    } catch {}
  }

  function extractHandleFromCard(card) {
    if (!card) return null;

    const dh = card.getAttribute("data-product-handle");
    if (dh) return dh;

    const a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;

    const href = a.getAttribute("href") || "";
    try {
      const u = new URL(href, location.origin);
      const parts = u.pathname.split("/").filter(Boolean);
      const idx = parts.indexOf("products");
      if (idx >= 0 && parts[idx + 1]) return parts[idx + 1];
    } catch {
      const m = href.match(/\/products\/([^/?#]+)/);
      if (m && m[1]) return m[1];
    }
    return null;
  }

  async function productsFromHandles(handles) {
    const ps = await Promise.all(
      (handles || []).map(async (h) => {
        try {
          const pj = await fetchJSON(`/products/${h}.js`);
          return {
            id: pj.id,
            handle: pj.handle,
            title: pj.title,
            url: pj.url,
            featured_image: pj.featured_image,
            price: pj.price,
            variants: pj.variants,
            _tnProductJSON: pj,
          };
        } catch {
          return null;
        }
      })
    );
    return ps.filter(Boolean);
  }

  async function addToCart(variantId) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    });
    if (!res.ok) throw new Error("No se pudo agregar");
    return res.json();
  }

  function openDrawerIfPossible() {
    const drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.open === "function") drawer.open();
  }

  async function refreshCartUI() {
    try {
      const res = await fetch(`/?sections=${SECTION_HANDLES.join(",")}`, { credentials: "same-origin" });
      if (!res.ok) return false;
      const data = await res.json();

      if (data["cart-drawer"]) {
        const html = data["cart-drawer"];
        const doc = new DOMParser().parseFromString(html, "text/html");

        const currentDrawerEl = document.querySelector("cart-drawer");
        const freshDrawerEl = doc.querySelector("cart-drawer");

        if (currentDrawerEl && freshDrawerEl) {
          const currentInner = currentDrawerEl.querySelector("#CartDrawer") || currentDrawerEl;
          const freshInner = freshDrawerEl.querySelector("#CartDrawer") || freshDrawerEl;
          currentInner.innerHTML = freshInner.innerHTML;
        } else {
          const currentSection = document.querySelector("#shopify-section-cart-drawer");
          if (currentSection) {
            const freshSection = doc.querySelector("#shopify-section-cart-drawer");
            currentSection.innerHTML = freshSection ? freshSection.innerHTML : (doc.body.innerHTML || html);
          }
        }
      }

      if (data["cart-icon-bubble"]) {
        const html = data["cart-icon-bubble"];
        const doc = new DOMParser().parseFromString(html, "text/html");

        const currentBubble = document.querySelector("#cart-icon-bubble");
        const freshBubble = doc.querySelector("#cart-icon-bubble");

        if (currentBubble && freshBubble) {
          currentBubble.innerHTML = freshBubble.innerHTML;
        } else {
          const currentSection = document.querySelector("#shopify-section-cart-icon-bubble");
          if (currentSection) {
            const freshSection = doc.querySelector("#shopify-section-cart-icon-bubble");
            currentSection.innerHTML = freshSection ? freshSection.innerHTML : (doc.body.innerHTML || html);
          }
        }
      }

      openDrawerIfPossible();
      watchCartDrawer();
      scheduleInitAll();

      try {
        const cartState = await fetchJSON("/cart.js");
        const triggerItem = Array.isArray(cartState.items) && cartState.items.length
          ? cartState.items[cartState.items.length - 1]
          : null;

        window.dispatchEvent(
          new CustomEvent("tn:cart-rendered", {
            detail: {
              source: "tn-upsell-refresh",
              productId: triggerItem && triggerItem.product_id ? String(triggerItem.product_id) : null,
            },
          })
        );
      } catch {}

      return true;
    } catch {
      return false;
    }
  }

  function bindAddButtons(root) {
    root.querySelectorAll("[data-tn-add]").forEach((btn) => {
      if (btn.dataset.tnBound === "1") return;
      btn.dataset.tnBound = "1";

      btn.addEventListener("click", async () => {
        const variantId = btn.getAttribute("data-variant-id") || btn.dataset.variantId;
        if (!variantId) return;

        const prev = btn.textContent;
        btn.disabled = true;
        btn.textContent = "Agregando...";

        const card = btn.closest(".tn-upsell-card");
        const block = btn.closest("[data-tn-upsell]");
        const key = block ? storageKey(block) : null;
        const handle = extractHandleFromCard(card);

        try {
          await addToCart(variantId);

          if (handle && key) {
            const current = loadHandles(key);
            if (current.length) saveHandles(key, current.filter((h) => h !== handle));
          }
          if (card) card.remove();

          const refreshed = await refreshCartUI();
          if (!refreshed && location.pathname === "/cart") location.reload();

          btn.textContent = "Agregado ✓";
        } catch {
          btn.textContent = "Error";
          setTimeout(() => {
            btn.textContent = prev;
            btn.disabled = false;
          }, 900);
        }
      });
    });
  }

  function getExcludeSet(block) {
    const exclude = new Set();
    if (block.dataset.excludeProductId) exclude.add(String(block.dataset.excludeProductId));

    if (block.dataset.cartProductIds) {
      block.dataset.cartProductIds
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean)
        .forEach((id) => exclude.add(String(id)));
    }
    return exclude;
  }

  async function fillVariantButtons(grid, products) {
    const cards = Array.from(grid.querySelectorAll(".tn-upsell-card"));

    for (let i = 0; i < products.length; i++) {
      const p = products[i];
      const card = cards[i];
      if (!card) continue;

      const btn = card.querySelector("[data-tn-add]");
      const priceEl = card.querySelector("[data-tn-price]") || card.querySelector(".tn-upsell-card__price");
      const imgEl = card.querySelector(".tn-upsell-card__media img");

      try {
        const pj = p._tnProductJSON ? p._tnProductJSON : await fetchJSON(`/products/${p.handle}.js`);

        if (priceEl) priceEl.textContent = formatMoney(pj.price);
        if (pj.featured_image && imgEl) imgEl.src = pj.featured_image;

        const v = (pj.variants || []).find((x) => x.available) || (pj.variants || [])[0];
        if (btn && v) {
          btn.disabled = false;
          btn.textContent = "Agregar";
          btn.setAttribute("data-variant-id", v.id);
          btn.dataset.variantId = v.id;

          if (pj.handle) card.setAttribute("data-product-handle", pj.handle);
        } else if (btn) {
          btn.textContent = "No disponible";
        }
      } catch {
        if (btn) btn.textContent = "No disponible";
      }
    }
  }

  async function initBlock(block) {
    const grid = block.querySelector("[data-tn-upsell-grid]");
    if (!grid) return;

    const currentKey = storageKey(block);
    const previousKey = block.dataset.tnKey || "";

    if (previousKey && previousKey !== currentKey) {
      block.dataset.tnHydrated = "0";
      grid.innerHTML = "";
    }

    block.dataset.tnKey = currentKey;

    if (grid.children.length && block.dataset.tnHydrated === "1") {
      bindAddButtons(block);
      return;
    }

    const mode = block.dataset.mode || "auto";
    if (mode === "manual") {
      bindAddButtons(block);
      block.dataset.tnHydrated = "1";
      return;
    }

    const exclude = getExcludeSet(block);
    const limit = Number(block.dataset.limit || 3);
    let products = [];

    const key = storageKey(block);
    const cachedHandles = loadHandles(key);

    if (cachedHandles.length) {
      const cachedProducts = await productsFromHandles(cachedHandles);
      products = cachedProducts.filter((p) => !exclude.has(String(p.id)));

      if (products.length) {
        grid.innerHTML = products.map(cardHTML).join("");
        await fillVariantButtons(grid, products);
        bindAddButtons(block);
        block.dataset.tnHydrated = "1";
        return;
      }

      saveHandles(key, []);
    }

    if (mode === "auto") {
      let productId = block.dataset.productId || block.dataset.firstProductId;

      if (!productId && block.dataset.context === "cart-drawer") {
        try {
          const cartState = await fetchJSON("/cart.js");
          const firstCartItem = Array.isArray(cartState.items) ? cartState.items[0] : null;

          if (firstCartItem && firstCartItem.product_id) {
            productId = String(firstCartItem.product_id);
            block.dataset.firstProductId = productId;

            const cartIds = (cartState.items || [])
              .map((item) => (item && item.product_id ? String(item.product_id) : ""))
              .filter(Boolean);

            if (cartIds.length) {
              block.dataset.cartProductIds = cartIds.join(",");
            }
          }
        } catch {}
      }

      if (!productId) return;

      try {
        const rec = await fetchJSON(`/recommendations/products.json?product_id=${productId}&limit=12&intent=complementary`);
        products = rec.products || [];
      } catch {}

      if (!products.length) {
        try {
          const rec2 = await fetchJSON(`/recommendations/products.json?product_id=${productId}&limit=12&intent=related`);
          products = rec2.products || [];
        } catch {}
      }

      products = uniqByHandle(products)
        .filter((p) => !exclude.has(String(p.id)))
        .slice(0, limit);
    }

    if (mode === "collection") {
      const handle = block.dataset.collectionHandle;
      if (!handle) return;

      try {
        const col = await fetchJSON(`/collections/${handle}/products.json?limit=50`);
        products = uniqByHandle(col.products || []).filter((p) => !exclude.has(String(p.id)));
        products = shuffle(products).slice(0, limit);
      } catch {
        products = [];
      }
    }

    if (!products.length) return;

    saveHandles(key, products.map((p) => p.handle));

    grid.innerHTML = products.map(cardHTML).join("");
    await fillVariantButtons(grid, products);
    bindAddButtons(block);
    block.dataset.tnHydrated = "1";
  }

  let initRunning = false;
  let initTimer = null;

  function scheduleInitAll() {
    if (initTimer) clearTimeout(initTimer);
    initTimer = setTimeout(() => initAll(), 80);
  }

  async function initAll() {
    if (initRunning) return;
    initRunning = true;

    try {
      const blocks = Array.from(document.querySelectorAll("[data-tn-upsell]"));
      for (const block of blocks) {
        await initBlock(block);
      }
    } finally {
      initRunning = false;
    }
  }

  let drawerObserver = null;

  function getDrawerTarget() {
    const drawerEl =
      document.querySelector("cart-drawer") ||
      document.getElementById("CartDrawer") ||
      document.querySelector(".cart-drawer");

    if (!drawerEl) return null;
    return drawerEl.querySelector?.("#CartDrawer") || drawerEl;
  }

  function watchCartDrawer() {
    try {
      if (drawerObserver) drawerObserver.disconnect();

      const queueIfNeeded = () => {
        if (initRunning) return;

        const blocks = Array.from(document.querySelectorAll('[data-tn-upsell][data-context="cart-drawer"]'));
        if (!blocks.length) return;

        const anyEmpty = blocks.some((block) => {
          const grid = block.querySelector("[data-tn-upsell-grid]");
          return grid && grid.children.length === 0;
        });

        if (anyEmpty) scheduleInitAll();
      };

      queueIfNeeded();

      const target = getDrawerTarget() || document.body;
      drawerObserver = new MutationObserver(() => {
        queueIfNeeded();
      });

      drawerObserver.observe(target === document.body ? document.body : target, {
        childList: true,
        subtree: true,
      });
    } catch {}
  }

  function resetDrawerUpsells() {
    document.querySelectorAll('[data-tn-upsell][data-context="cart-drawer"]').forEach((block) => {
      block.dataset.tnHydrated = "0";
      const grid = block.querySelector("[data-tn-upsell-grid]");
      if (grid) grid.innerHTML = "";
    });
  }

  function reinitDrawerUpsells(delay = 120) {
    setTimeout(() => {
      resetDrawerUpsells();
      watchCartDrawer();
      scheduleInitAll();
    }, delay);
  }

  let booted = false;

  function boot() {
    if (booted) return;
    booted = true;

    initAll();
    watchCartDrawer();

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        reinitDrawerUpsells(180);
      });
    }

    window.addEventListener("tn:cart-rendered", async () => {
      try {
        const cartState = await fetchJSON("/cart.js");
        const triggerItem =
          Array.isArray(cartState.items) && cartState.items.length
            ? cartState.items[cartState.items.length - 1]
            : null;

        const cartIds = (cartState.items || [])
          .map((item) => (item && item.product_id ? String(item.product_id) : ""))
          .filter(Boolean)
          .join(",");

        document.querySelectorAll('[data-tn-upsell][data-context="cart-drawer"]').forEach((block) => {
          if (triggerItem && triggerItem.product_id) {
            block.dataset.productId = String(triggerItem.product_id);
            block.dataset.firstProductId = String(triggerItem.product_id);
          } else {
            delete block.dataset.productId;
            delete block.dataset.firstProductId;
          }

          if (cartIds) {
            block.dataset.cartProductIds = cartIds;
          } else {
            delete block.dataset.cartProductIds;
          }
        });
      } catch {}

      reinitDrawerUpsells(80);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
